import { BranchType } from 'api-new/generated';
import { create } from 'zustand';

type EditModalState = {
  id?: number;
  wipNo?: number;
  regNo?: string | null;
  branch?: BranchType;
};

type WarrantyLogEditState = {
  isLoading: boolean;
  state?: EditModalState;
  isShowEditModal?: boolean;
  showModal: (id: number) => void;
  closeModal: () => void;
  setState: (state: EditModalState) => void;
  setLoading: (isLoading: boolean) => void;
};

export const useEditModalStore = create<WarrantyLogEditState>((set) => ({
  isLoading: false,
  isShowEditModal: false,
  showModal: (id: number) => set({ isShowEditModal: true, state: { id: id } }),
  closeModal: () => set({ isShowEditModal: false, state: undefined }),
  setState: (state: EditModalState) => set((prev) => ({ state: { ...state, id: prev?.state?.id } })),
  setLoading: (isLoading) => set({ isLoading: isLoading })
}));
